import Dropdown from '@cred/react-editors/dropdown'
import withFieldChangeEvent from '@cred/react-analytics/hoc/withFieldChangeEvent'

const DropdownInputWithAnalytics = withFieldChangeEvent(Dropdown)

export default DropdownInputWithAnalytics
